import React from 'react'
import { HeaderPopupPage } from '../CreatePopup';
import useStyles from '../style'
import { Grid, Typography } from '@mui/material';
import CkeditorComp from '@components/common/ckeditor/Ckeditor';
const CenterPopup = ()=>{
    const classes = useStyles();
    return (
        <>
            <HeaderPopupPage path='/admin/popup-management'/>
            <div className={classes.root}>
                <Grid container display='flex' alignItems='center' justifyContent='center' direction='column'>
                    <Grid item>
                        <Typography className={classes.title}>
                            Popup Center
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography className={classes.text}>
                            Popup nằm ở vị trí trung tấm của website
                        </Typography>
                    </Grid>
                </Grid>
                <CkeditorComp 
                    title="Popup Center" 
                    content="Popup nằm ở vị trí trung tấm của website"
                    isCenter={true}
                    popupType="Center"
                />
            </div>
        </>
    )
}
export default CenterPopup;
